/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components
import AuthNavbar from "components/Navbars/DashboardAuthNavbar/Index";
import AuthFooter from "components/Footers/DashboardAuthFooter";
import Footer from "components/Footers/StoreFooter/Footer"

import routes from "routes.js";

//css
import "./DashboardAuth.css";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="background">
        <div className="main-content background" ref={mainContent}>
          
          <div className="header py-4 py-lg-6 py-md-6">
            <AuthNavbar />
          </div>
          {/* Page content */}
          <Container className=" pb-5">
            <Row className="justify-content-center">
              <Routes>
                {getRoutes(routes)}
                <Route path="*" element={<Navigate to="/auth/login" replace />} />
              </Routes>
            </Row>
          </Container>
        </div>
      <Footer />

      </div>

    </>
  );
};

export default Auth;
